import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  checkCodexSignInInputSchema,
  codexSignInCheckSchema,
  finishClaudeSignInInputSchema,
  harnessLoginSchema,
  harnessLoginsInputSchema,
  harnessLoginsOutputSchema,
  harnessSignInSchema,
  removeHarnessLoginInputSchema,
  startHarnessSignInInputSchema,
} from "./harness-login.schemas.ts";
import {
  deleteVaultSecretInputSchema,
  listVaultSecretsInputSchema,
  listVaultSecretsOutputSchema,
  okSchema,
  saveVaultLoginInputSchema,
  saveVaultSecretInputSchema,
  vaultSecretSchema,
} from "./vault.schemas.ts";

// Declared once. The process binds access, the `remote-agents` flag and handlers; the client
// derives its hooks. No output carries a value. A member's own Claude or Codex login is their
// own credential (`ownCredential`): staff visiting as the member and an agent's key are refused.
export const vaultTrpcContract = defineTrpcContract("vault", {
  list: query({ input: listVaultSecretsInputSchema, output: listVaultSecretsOutputSchema }),
  save: mutation({ input: saveVaultSecretInputSchema, output: vaultSecretSchema }),
  saveLogin: mutation({ input: saveVaultLoginInputSchema, output: vaultSecretSchema }),
  delete: mutation({ input: deleteVaultSecretInputSchema, output: okSchema }),
  harnessLogins: query({ input: harnessLoginsInputSchema, output: harnessLoginsOutputSchema }),
  startHarnessSignIn: mutation({
    input: startHarnessSignInInputSchema,
    output: harnessSignInSchema,
    ownCredential: true,
  }),
  finishClaudeSignIn: mutation({
    input: finishClaudeSignInInputSchema,
    output: harnessLoginSchema,
    ownCredential: true,
  }),
  checkCodexSignIn: mutation({
    input: checkCodexSignInInputSchema,
    output: codexSignInCheckSchema,
    ownCredential: true,
  }),
  removeHarnessLogin: mutation({
    input: removeHarnessLoginInputSchema,
    output: okSchema,
    ownCredential: true,
  }),
});
